export const saleTags = [
  {
    id: '<%= COMPANY_ADDRESS %>',
    name: 'Company Address'
  },
  {
    id: '<%= COMPANY_EMAIL %>',
    name: 'Company Email'
  },
  {
    id: '<%= COMPANY_LOGO %>',
    name: 'Company Logo'
  },
  {
    id: '<%= COMPANY_NAME %>',
    name: 'Company Name'
  },
  {
    id: '<%= COMPANY_PHONE_NO %>',
    name: 'Company Phone Number'
  },
  // {
  //   id: '<%= COMPANY_TAX %>',
  //   name: 'Company Tax Information'
  // },
  {
    id: '<% if (TRANSACTION.CUSTOMER_REFERENCE) { %> <%- TRANSACTION.CUSTOMER_REFERENCE.COMMENT %> <% } %>',
    name: 'Customer Reference'
  },
  {
    id: '<%= COMPANY_LEGAL_NAME %>',
    name: 'Company Legal Name'
  },
  {
    id: '<%= TRANSACTION.CUSTOMER_RECEIPT %>',
    name: 'Customer Receipt'
  },
  {
    id: '<%= TRANSACTION.DATE %>',
    name: 'Company Transaction Date'
  },
  {
    id: '<%= COMPANY.TRANSACTION.DATETIME %>',
    name: 'Company Transaction Date and Time'
  },
  {
    id: '<%= TRANSACTION.TIME %>',
    name: 'Company Transaction Time'
  },
  {
    id: '<%= TRANSACTION.CUSTOMER.ADDRESS %>',
    name: 'Customer Address'
  },
  {
    id: '<%= TRANSACTION.CUSTOMER.EMAIL %>',
    name: 'Customer Email'
  },
  {
    id: '<%= TRANSACTION.CUSTOMER.NAME %>',
    name: 'Customer Name ID'
  },
  {
    id: '<%= TRANSACTION.CUSTOMER.PHONE %>',
    name: 'Customer Phone Number'
  },
  {
    id: '<%- LINE.COMMENT %>',
    name: 'Line Comment'
  },
  {
    id: '<%- LINE.DISCOUNT_UNIT_APPLIED %>',
    name: 'Line Discount Unit Applied'
  },
  {
    id: '<%- LINE.ITEM.NAME %>',
    name: 'Line Item Name'
  },
  {
    id: '<%- LINE.QUANTITY %>',
    name: 'Line Quantity'
  },
  {
    id: '<%- LINE.REASON_CODE.NAME %>',
    name: 'Line Reason Code Name'
  },
  {
    id: '<%- LINE.RETAIL_PRICE %>',
    name: 'Line Retail Price'
  },
  {
    id: '<%- LINE.RETAIL_PRICE_INC_TAX %>',
    name: 'Line Retail Price Inc Tax'
  },
  {
    id: '<%- LINE.SALE_PRICE %>',
    name: 'Line Sale Price'
  },
  {
    id: '<%- LINE.SALE_PRICE_EX_TAX %>',
    name: 'Line Sale Price Ex Tax'
  },
  {
    id: '<%- LINE.SALES_REP.NAME %>',
    name: 'Line Tax Total'
  },
  {
    id: '<%- PAYMENT.AMOUNT %>',
    name: 'Payment amount'
  },
  {
    id: '<%- PAYMENT.CHANGE %>',
    name: 'Payment change'
  },
  {
    id: '<%- PAYMENT.DATE %>',
    name: 'Payment date'
  },
  {
    id: '<%- PAYMENT.TIME %>',
    name: 'Payment time'
  },
  {
    id: '<%- PAYMENT.PAYMENT_TYPE.NAME %>',
    name: 'Payment type name'
  },
  {
    id: '<%= POINTS_BAL %>',
    name: 'Points Balance'
  },
  {
    id: '<%= POINTS_COLLECTED %>',
    name: 'Points Collected'
  },
  {
    id: '<%= TRANSACTION.REFERENCE_ID %>',
    name: 'Reference ID'
  },
  {
    id: '<%= TRANSACTION.SALES_REP.NAME %>',
    name: 'Sales Rep First Name ID'
  },
  {
    id: '<%= TRANS_BAR_CODE %>',
    name: 'Transaction Barcode'
  },
  {
    id: '<%= TRANSACTION.CASH_ROUNDING %>',
    name: 'Transaction Cash Rounding'
  },
  {
    id: '<%= TRANSACTION.CHANGE %>',
    name: 'Transaction Change'
  },
  {
    id: '<%= TRANSACTION.COMMENT %>',
    name: 'Transaction Comment'
  },
  {
    id: '<%= TRANSACTION.DEVICE.DEVICE_ID %>',
    name: 'Transaction Device ID'
  },
  {
    id: '<%= TRANSACTION.DEVICE.DEVICE_REFERENCE %>',
    name: 'Transaction Device Reference'
  },
  {
    id: '<%= TRANSACTION.DISCOUNTTOTAL %>',
    name: 'Transaction Discount Total'
  },
  {
    id: '<% _.forEach(TRANSACTION.ITEM_LINES, function(LINE) { %><% }); %>',
    name: 'Transaction Item Lines'
  },
  {
    id: '<% _.forEach(TRANSACTION.PAYMENTS, function(PAYMENT) { %><% }); %>',
    name: 'Transaction Payments'
  },
  {
    id: '<%= TRANSACTION.REASON_CODE %>',
    name: 'Transaction Reason Code'
  },
  {
    id: '<%= TRANSACTION.SUBTOTAL %>',
    name: 'Transaction Subtotal'
  },
  {
    id: '<%= TRANSACTION.TAXTOTAL %>',
    name: 'Transaction Tax Total'
  },
  {
    id: '<%= TRANSACTION.TOTAL %>',
    name: 'Transaction Total'
  },
  {
    id: '<%= TRANSACTION.TYPE.NAME %>',
    name: 'Transaction Type'
  }
];

export const saleTagsAdmin = [
  {
    id: '{{subsidiary.address}}',
    name: 'Company Address'
  },
  {
    id: '{{subsidiary.email}}',
    name: 'Company Email'
  },
  {
    id: '{{subsidiary.company_logo}}',
    name: 'Company Logo'
  },
  {
    id: '{{subsidiary.name}}',
    name: 'Company Name'
  },
  {
    id: '{{subsidiary.phone_number}}',
    name: 'Company Phone Number'
  },
  {
    id: '{{subsidiary.legal_company_name}}',
    name: 'Company Legal Name'
  },
  {
    id: '{{customer.address}}',
    name: 'Customer Address'
  },
  {
    id: '{{customer.email}}',
    name: 'Customer Email'
  },
  {
    id: '{{customer.name}}',
    name: 'Customer Name'
  },
  {
    id: '{{customer.phone}}',
    name: 'Customer Phone Number'
  },
  {
    id: '{{comment}}',
    name: 'Line Comment'
  },
  {
    id: '{{discount_unit_applied}}',
    name: 'Line Discount Unit Applied'
  },
  {
    id: '{{item.name}}',
    name: 'Line Item Name'
  },
  {
    id: '{{quantity}}',
    name: 'Line Quantity'
  },
  {
    id: '{{reason_code.name}}',
    name: 'Line Reason Code Name'
  },
  {
    id: '{{retail_price}}',
    name: 'Line Retail Price'
  },
  {
    id: '{{retail_price_inc_tax}}',
    name: 'Line Retail Price Inc Tax'
  },
  {
    id: '{{sale_price}}',
    name: 'Line Sale Price'
  },
  {
    id: '{{sale_price_ex_tax}}',
    name: 'Line Sale Price Ex Tax'
  },
  {
    id: '{{sales_rep.name}}',
    name: 'Line Tax Total'
  },
  {
    id: '{{payment.amount}}',
    name: 'Payment amount'
  },
  {
    id: '{{payment.change}}',
    name: 'Payment change'
  },
  {
    id: '{{formatDateTime payment.date}}',
    name: 'Payment date'
  },
  {
    id: '{{formatTime payment.time}}',
    name: 'Payment time'
  },
  {
    id: '{{payment.payment_type.name}}',
    name: 'Payment type name'
  },
  {
    id: '{{points_bal}}',
    name: 'Points Balance'
  },
  {
    id: '{{points_collected}}',
    name: 'Points Collected'
  },
  {
    id: '{{transaction.reference_id}}',
    name: 'Reference ID'
  },
  {
    id: '{{transaction.sales_rep.name}}',
    name: 'Sales Rep First Name'
  },
  {
    id: '{{transaction.bar_code}}',
    name: 'Transaction Barcode'
  },
  {
    id: '{{transaction.cash_rounding}}',
    name: 'Transaction Cash Rounding'
  },
  {
    id: '{{transaction.change}}',
    name: 'Transaction Change'
  },
  {
    id: '{{transaction.comment}}',
    name: 'Transaction Comment'
  },
  {
    id: '{{formatDate transaction.created_datetime}}',
    name: 'Transaction Date'
  },
  {
    id: '{{formatDateTime transaction.created_datetime}}',
    name: 'Transaction Date and Time'
  },
  {
    id: '{{transaction.device.device_id}}',
    name: 'Transaction Device ID'
  },
  {
    id: '{{transaction.device.device_reference}}',
    name: 'Transaction Device Reference'
  },
  {
    id: '{{transaction.discounttotal}}',
    name: 'Transaction Discount Total'
  },
  {
    id: '{{each transaction.item_lines}}\n\xA0\xA0Enter your code here regarding lines\n{{/each}}',
    name: 'Transaction Item Lines'
  },
  {
    id: '{{each transaction.payments}}\n\xA0\xA0Enter your code here regarding payments\n{{/each}}',
    name: 'Transaction Payments'
  },
  {
    id: '{{transaction.reason_code}}',
    name: 'Transaction Reason Code'
  },
  {
    id: '{{transaction.subtotal}}',
    name: 'Transaction Subtotal'
  },
  {
    id: '{{transaction.taxtotal}}',
    name: 'Transaction Tax Total'
  },
  {
    id: '{{transaction.total}}',
    name: 'Transaction Total'
  },
  {
    id: '{{formatTime transaction.created_datetime}}',
    name: 'Transaction Time'
  },
  {
    id: '{{transaction.type.name}}',
    name: 'Transaction Type'
  }
];

export const chitTags = [
  {
    id: '<%= AMOUNT %>',
    name: 'Count'
  },
  {
    id: '<%= CURRENCY_AMOUNT %>',
    name: 'Foreign Amount'
  },
  {
    id: '<%= EXCHANGE_RATE %>',
    name: 'Foreign Exchange Rate'
  },
  {
    id: '<%= CURRENCY.CODE %>',
    name: 'Currency'
  },
  // {
  //   id       : '<%= DEFAULT_FLOAT %>',
  //   name     : 'Default float'
  // },
  {
    id: '<%= EMPLOYEE.NAME %>',
    name: 'Employee'
  },
  {
    id: '<%= LOCATION.NAME %>',
    name: 'Location'
  },
  // {
  //   id       : '<%= MOVEMENT_AMOUNT %>',
  //   name     : 'Movement amount'
  // },
  {
    id: '<%= MOVEMENT_TYPE.NAME %>',
    name: 'Movement type'
  },
  {
    id: '<%= OPENED_BY.NAME %>',
    name: 'Opened by'
  },
  {
    id: '<%= OPENED_DATE %>',
    name: 'Opened date'
  },
  {
    id: '<%= REFERENCE_ID %>',
    name: 'Reference ID'
  },
  {
    id: '<%= REGISTER.NAME %>',
    name: 'Register'
  },
  {
    id: '<%= SHIFT_TYPE.NAME %>',
    name: 'Shift type'
  },
  {
    id: '<%= SUBSIDIARY.NAME %>',
    name: 'Subsidiary'
  },
  {
    id: '<%= TILL.NAME %>',
    name: 'Till'
  },
  {
    id: '<%= TILL.DEVICE_ID %>',
    name: 'Till ID'
  },
  {
    id: '<%= TILL.STATUS.NAME %>',
    name: 'Till status'
  },
  {
    id: '<%= TOTAL_AMOUNT %>',
    name: 'Total count'
  }
  // {
  //   id       : '<%= CURRENT_TOTAL_AMOUNT %>',
  //   name     : 'Total count (current)'
  // },
  // {
  //   id       : '<%= CURRENT_VARIANCE_AMOUNT %>',
  //   name     : 'Variance (current)'
  // },
  // {
  //   id       : '<%= VARIANCE %>',
  //   name     : 'Variance'
  // },
];

export const tillSummaryTags = [
  {
    id: '<%= TILL_COUNT_SOD %>',
    name: 'Till count (start of day)'
  },
  {
    id: '<%= VARIANCE_SOD %>',
    name: 'Variance (start of day)'
  },
  {
    id: '<%= PETTY_CASH %>',
    name: 'Petty cash'
  },
  {
    id: '<%= BANK_DROP %>',
    name: 'Bank drop'
  },
  {
    id: '<%= TILL_SWEEP %>',
    name: 'Till sweep'
  },
  {
    id: '<%= TILL_TOP_UP %>',
    name: 'Till top up'
  },
  {
    id: '<%= ENVELOP_DROP %>',
    name: 'Envelop drop'
  },
  {
    id: '<%= CASH %>',
    name: 'Cash'
  },
  {
    id: '<%= EXPECTED_CASH %>',
    name: 'Expected cash'
  },
  {
    id: '<%= TILL_COUNT_EOD %>',
    name: 'Till count (end of day)'
  },
  {
    id: '<%= VARIANCE_EOD %>',
    name: 'Variance (end of day)'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.TILL_COUNT_SOD %>',
    name: 'Till count (start of day)'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.PETTY_CASH %>',
    name: 'Petty cash'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.BANK_DROP %>',
    name: 'Bank drop'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.TILL_SWEEP %>',
    name: 'Till sweep'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.TILL_TOP_UP %>',
    name: 'Till top up'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.ENVELOP_DROP %>',
    name: 'Envelop drop'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.CASH %>',
    name: 'Cash'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.EXPECTED_CASH %>',
    name: 'Expected cash'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.TILL_COUNT_EOD %>',
    name: 'Till count (end of day)'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.CURRENCY.CODE %>',
    name: 'Foreign currency code'
  },
  {
    id: '<%= FOREIGN_TILL_SUMMARY.CURRENCY.CODE %>',
    name: 'Local currency code'
  }
];

export const purchaseTags = [
  {
    id: '{{created_datetime}}',
    name: 'Created date'
  },
  {
    id: '{{created_by.name}}',
    name: 'Created by'
  },
  {
    id: '{{currency.name}}',
    name: 'Currency'
  },
  {
    id: '{{dispatched_date}}',
    name: 'Dispatched date'
  },
  {
    id: '{{dispatched_method.name}}',
    name: 'Dispatched method'
  },
  {
    id: '{{exchange_rate}}',
    name: 'Exchange rate'
  },
  {
    id: '{{expected_eta}}',
    name: 'Expected ETA'
  },
  {
    id: '{{location.name}}',
    name: 'Location'
  },
  {
    id: '{{location.address1}}',
    name: 'Location address 1'
  },
  {
    id: '{{location.address2}}',
    name: 'Location address 2'
  },
  {
    id: '{{location.address3}}',
    name: 'Location address 3'
  },
  {
    id: '{{location.city}}',
    name: 'Location city'
  },
  {
    id: '{{location.country.name}}',
    name: 'Location country'
  },
  {
    id: '{{location.state}}',
    name: 'Location state'
  },
  {
    id: '{{location.zipcode}}',
    name: 'Location zip code'
  },
  {
    id: '{{item.name}}',
    name: 'Line item'
  },
  {
    id: '{{currency.name}}',
    name: 'Line currency'
  },
  {
    id: '{{item_type.name}}',
    name: 'Line item type'
  },
  {
    id: '{{tax_group.name}}',
    name: 'Tax group'
  },
  {
    id: '{{tax_rate}}',
    name: 'Tax rate'
  },
  {
    id: '{{comment}}',
    name: 'Line comment'
  },
  {
    id: '{{quantity}}',
    name: 'Line quantity'
  },
  {
    id: '{{reason_code.name}}',
    name: 'Line reason code'
  },
  {
    id: '{{tax_amount}}',
    name: 'Line tax amount'
  },
  {
    id: '{{tax_rate}}',
    name: 'Line tax rate'
  },
  {
    id: '{{total}}',
    name: 'Line total'
  },
  {
    id: '{{total_ex_tax}}',
    name: 'Line total (ex tax)'
  },
  {
    id: '{{unit_cost}}',
    name: 'Line unit cost'
  },
  {
    id: '{{unit_price_location}}',
    name: 'Line unit price (location)'
  },
  {
    id: '{{available_pre_order}}',
    name: 'Available pre order'
  },
  {
    id: '{{remaining_quantity}}',
    name: 'Remaining quantity'
  },
  {
    id: '{{suggested_reorder_quantity}}',
    name: 'Reorder quantity'
  },
  {
    id: '{{note}}',
    name: 'Note'
  },
  {
    id: '{{status.name}}',
    name: 'Status'
  },
  {
    id: '{{sub_total}}',
    name: 'Sub total'
  },
  {
    id: '{{subsidiary.name}}',
    name: 'Subsidiary'
  },
  {
    id: '{{subsidiary.address1}}',
    name: 'Subsidiary address 1'
  },
  {
    id: '{{subsidiary.address2}}',
    name: 'Subsidiary address 2'
  },
  {
    id: '{{subsidiary.address3}}',
    name: 'Subsidiary address 3'
  },
  {
    id: '{{subsidiary.city}}',
    name: 'Subsidiary city'
  },
  {
    id: '{{subsidiary.country.name}}',
    name: 'Subsidiary country'
  },
  {
    id: '{{subsidiary.state}}',
    name: 'Subsidiary state'
  },
  {
    id: '{{subsidiary.zipcode}}',
    name: 'Subsidiary zip code'
  },
  {
    id: '{{supplier.name}}',
    name: 'Supplier'
  },
  {
    id: '{{supplier.address1}}',
    name: 'Supplier address 1'
  },
  {
    id: '{{supplier.address2}}',
    name: 'Supplier address 2'
  },
  {
    id: '{{supplier.address3}}',
    name: 'Supplier address 3'
  },
  {
    id: '{{supplier.city}}',
    name: 'Supplier city'
  },
  {
    id: '{{supplier.country.name}}',
    name: 'Supplier country'
  },
  {
    id: '{{supplier.state}}',
    name: 'Supplier state'
  },
  {
    id: '{{supplier.zipcode}}',
    name: 'Supplier zip code'
  },
  {
    id: '{{total}}',
    name: 'Total'
  },
  {
    id: '{{total_tax}}',
    name: 'Total tax'
  }
  // BASE LEVEL
  // "alternate_class": null,
  // "authorised_date": null,
  // "brand": null,
  // "classification": null,
];

export const creditCertificateTags = [
  {
    id: '<%= AVAILABLE_FROM %>',
    name: 'Available from'
  },
  {
    id: '<%= AVAILABLE_TO %>',
    name: 'Available to'
  },
  {
    id: '<%= AMOUNT %>',
    name: 'Amount'
  },
  {
    id: '<%= AMOUNT_REMAINING %>',
    name: 'Amount remaining'
  },
  {
    id: '<%= CERTIFICATE_TYPE.NAME %>',
    name: 'Certificate type'
  },
  {
    id: '<%= CUSTOMER.NAME %>',
    name: 'Customer'
  },
  {
    id: '<%= CERTIFICATE_ID %>',
    name: 'Certificate ID'
  }
];

export const entityTags = [
  {
    id: '{{alias}}',
    name: 'Alias'
  },
  {
    id: '{{birth_month}}',
    name: 'Birth month'
  },
  {
    id: '{{created_by.name}}',
    name: 'Created by'
  },
  {
    id: '{{created_datetime}}',
    name: 'Created date'
  },
  {
    id: '{{date_of_birth}}',
    name: 'Date of birth'
  },
  {
    id: '{{email}}',
    name: 'Email'
  },
  {
    id: '{{first_name}}',
    name: 'First name'
  },
  {
    id: '{{last_name}}',
    name: 'Last name'
  },
  {
    id: '{{last_updated}}',
    name: 'Last updated'
  },
  {
    id: '{{last_updated_by.name}}',
    name: 'Last updated by'
  },
  {
    id: '{{name}}',
    name: 'Name'
  },
  {
    id: '{{reference_id}}',
    name: 'Reference ID'
  },
  {
    id: '{{register_pin}}',
    name: 'Register PIN'
  }
];

export const inventoryTags = [
  {
    id: '{{comment}}',
    name: 'Comment'
  },
  {
    id: '{{created_datetime}}',
    name: 'Created date'
  },
  {
    id: '{{processed_date}}',
    name: 'Processed date'
  },
  {
    id: '{{reference_id}}',
    name: 'Reference ID'
  },
  {
    id: '{{item.name}}',
    name: 'Line Item'
  },
  {
    id: '{{item.number}}',
    name: 'Line Item Number'
  },
  {
    id: '{{item_uom.uom.name}}',
    name: 'Line Item UOM'
  },
  {
    id: '{{item_uom.uom.name}}',
    name: 'Line Item UOM'
  },
  {
    id: '{{quantity_available}}',
    name: 'Line Item Quantity Available'
  },
  {
    id: '{{quantity_transfer}}',
    name: 'Line Item Quantity Transfer'
  },
  {
    id: '{{quantity_receive}}',
    name: 'Line Item Quantity Receive'
  },
  {
    id: '{{uom_quantity_available}}',
    name: 'Line Item UOM Quantity Available'
  },
  {
    id: '{{uom_quantity_transfer}}',
    name: 'Line Item UOM Quantity Transfer'
  },
  {
    id: '{{uom_quantity_receive}}',
    name: 'Line Item UOM Quantity Receive'
  },
  {
    id: '{{from_subsidiary.name}}',
    name: 'From Subsidiary'
  },
  {
    id: '{{from_subsidiary.address1}}',
    name: 'From Subsidiary address 1'
  },
  {
    id: '{{from_subsidiary.address2}}',
    name: 'From Subsidiary address 2'
  },
  {
    id: '{{from_subsidiary.address3}}',
    name: 'From Subsidiary address 3'
  },
  {
    id: '{{from_subsidiary.city}}',
    name: 'From Subsidiary city'
  },
  {
    id: '{{from_subsidiary.country.name}}',
    name: 'From Subsidiary country'
  },
  {
    id: '{{from_subsidiary.state}}',
    name: 'From Subsidiary state'
  },
  {
    id: '{{from_subsidiary.zipcode}}',
    name: 'From Subsidiary zip code'
  },
  {
    id: '{{from_subsidiary.business_company_number}}',
    name: 'From Subsidiary zip code'
  },
  {
    id: '{{from_location.name}}',
    name: 'From Location'
  },
  {
    id: '{{from_location.address1}}',
    name: 'From Location address 1'
  },
  {
    id: '{{from_location.address2}}',
    name: 'From Location address 2'
  },
  {
    id: '{{from_location.address3}}',
    name: 'From Location address 3'
  },
  {
    id: '{{from_location.city}}',
    name: 'From Location city'
  },
  {
    id: '{{from_location.country.name}}',
    name: 'From Location country'
  },
  {
    id: '{{location.state}}',
    name: 'From Location state'
  },
  {
    id: '{{location.zipcode}}',
    name: 'From Location zip code'
  },
  {
    id: '{{to_location.name}}',
    name: 'To Location'
  },
  {
    id: '{{to_location.address1}}',
    name: 'To Location address 1'
  },
  {
    id: '{{to_location.address2}}',
    name: 'To Location address 2'
  },
  {
    id: '{{to_location.address3}}',
    name: 'To Location address 3'
  },
  {
    id: '{{to_location.city}}',
    name: 'To Location city'
  },
  {
    id: '{{to_location.country.name}}',
    name: 'To Location country'
  },
  {
    id: '{{to_location.state}}',
    name: 'To Location state'
  },
  {
    id: '{{to_location.zipcode}}',
    name: 'To Location zip code'
  },
];
